import { IntegrationInitializationModal } from '../IntegrationInitializationModal'

import { useModals } from 'almanac-ui/Modal'
import { Twitter } from 'blaze-ui/icons'

import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { IntegrationNotice } from '../IntegrationNotice'
import Styles from '../IntegrationInitializationModal.module.scss'

export const XNotice = () => (
  <IntegrationNotice
    connectionGuideLink="https://help.blaze.ai/en/articles/9559679-connect-blaze-to-x-formerly-twitter"
    message={
      <div className={Styles.message}>
        Please read our detailed guide to connect your X/Twitter account if you run into any issues.
      </div>
    }
  />
)

const XInitialization = ({ userIsAttemptingToPost = false, useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const title = userIsAttemptingToPost ? 'Set up your X/Twitter integration' : 'Connect X/Twitter Account'

  const handleConfirm = () => {
    initiateOauth(ExternalIntegrationEnum.X)
  }

  const sharedProps = {
    notice: <XNotice />,
    providerName: 'X/Twitter',
    onClose: closeModal,
    icon: <Twitter size={32} />,
    title: title,
    onConfirm: handleConfirm,
    primaryButtonText: 'Go to X/Twitter',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default XInitialization
